module.exports = __webpack_public_path__ + "img/recycling@2x.f4d073c.webp";